import { Component, Host, Prop, h } from '@stencil/core';

import { CONSUMER_MARKET_CONFIDENCE_DEFAULT, ConsumerMarketConfidence } from '../../../../../interfaces/interface.consumer-market-confidence';

@Component({
  tag: 'key-factor-element',
  styleUrl: 'key-factor-element.css',
})
export class KeyFactorElement {
  @Prop() keyFactor: ConsumerMarketConfidence = CONSUMER_MARKET_CONFIDENCE_DEFAULT;
  @Prop() onModalOpen: () => void = () => {};

  render() {
    const { onModalOpen } = this;
    const { type, description, titlePrice, hasIcon, isPositiveValue, displayValue, shouldDisplay } = this.keyFactor;

    if (!shouldDisplay) {
      return null;
    }

    const priceClass = {
      'font-bold text-center border-solid border-2 rounded-md py-1 @xs:px-8 @md:px-10 w-9 @lg:min-w-20 flex flex-col justify-center items-center': true,
      'text-clrs-green border-clrs-green': isPositiveValue,
      'text-clrs-red border-clrs-red': !isPositiveValue,
    };

    const iconClass = {
      'cursor-pointer': true,
      visible: hasIcon,
      invisible: !hasIcon,
    };

    return (
      <Host>
        <div class="flex-1 flex justify-between items-center mt-2">
          <div>
            <div class="font-bold text-base inline-flex items-center">
              {type}
              <span
                class={iconClass}
                onClick={() => onModalOpen()}
                onMouseOver={() => onModalOpen()}
                role="button"
                tabIndex={hasIcon ? 0 : -1}
                aria-label={hasIcon ? `More information about ${type}` : ''}>
                <svg-icon icon="alert-info" height="16px" width="16px" class="mt-1 ml-1" aria-label="Information icon" />
              </span>
            </div>
            <div class="text-xs whitespace-break-spaces w-fit">{description}</div>
          </div>
          <div class={priceClass}>
            <span class="@lg:whitespace-nowrap text-xs uppercase">{titlePrice}</span>
            <span class="whitespace-nowrap @xs:text-sm @md:text-base">{displayValue}</span>
          </div>
        </div>
      </Host>
    );
  }
}
